<template>
  <div :counterTextObserver="productObserver" :id="dataCounterText">
    <Observer :options="{ rootMargin: '-50px' }" :id="cardId" />
    <product-card-template
      :smallCards="smallCards"
      :isOnCartPage="isOnCartPage"
      :quantity="quantity"
      :cardRounded="cardRounded"
      :hideProductImg="hideProductImg"
      :imageSrc="getImageUrl(productItem)"
      :imageArray="getImageArray(productItem)"
      :isInModal="isInModal"
      :isFavourite="isFavourite"
      :isVeg="getIsVeg(productItem)"
      :displayName="productItem?.displayName"
      :description="productItem?.description"
      :isComboItem="productItem?.comboUID"
      :currentPrice="getCurrentPrice(productItem)"
      :regularPrice="getRegularPrice(productItem)"
      :isCustomizable="isCustomizable"
      :customizations="customizations"
      :bestseller-tag="isBestsellerTagVisible"
      :newTag="isNewTagVisible"
      :productId="getProductSkuId()"
      :showFullInfo="showFullInfo"
      :dataModuleProps="dataModuleProps"
      :metaData="productItem?.metadataMap"
      :product-rating="getProductRating(productItem)"
      :dataHorizontalCarousel="dataHorizontalCarousel"
      @update-show-product-card-in-modal="updateShowProductCardInModal"
      @update-favourite="updateFavourite"
      @removefromcart="removefromcart"
      @addtocart="addtocart"
      :outOfStock="isOutOfStock"
      v-if="!isItemDisabled"
    ></product-card-template>
    <div v-if="showUpsell" class="pl16">
      <h2 class="bold fs-18">You may also like</h2>
      <upsell
        :type="'card'"
        :product="productItem"
        :parentProductQuantity="quantity"
      ></upsell>
    </div>
  </div>
</template>

<script setup></script>

<script>
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import ProductCardTemplate from "./ProductCardTemplate.vue";
import {
  EVENT_ADD_FROM_SEARCH,
  EVENT_CLICK_FAVOURITE_BUTTON,
  EVENT_ITEM_ADD,
} from "../helpers/analyticsEvents";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";

import LocalStorageFunc from "../helpers/localStorageFunc";
import Utility from "../helpers/utility.js";
import ItemRemovePopup from "./ItemRemovePopup.vue";
import Observer from "./Observer.vue";
import GenericModal from "./GenericModal.vue";
import Upsell from "./Upsell.vue";
import { DISABLED_ORDER_TYPE } from "../helpers/OrderStatusConstants";

export default {
  name: "HongsProductCard",
  props: {
    dataItem: { required: true, default: {} },
    dataItemIndex: { required: false, default: 0 },
    dataSmallCards: { required: false, default: false },
    dataHorizontalCarousel: { required: false, default: false },
    dataCardRounded: { required: false, default: false },
    dataHideImage: { required: false, default: false },
    dataCounterText: { required: false, default: "" },
    isInModal: { required: false, default: false },
    isOnCartPage: { required: false, default: false },
    showFullInfo: { required: false, default: false },
    dataCategoryId: { required: false, default: false },
    isOutOfStock: { required: false, default: false },
    dataModuleProps: { required: false, default: [] },
    dataCategoryName: { required: false, default: false },
    searchText: { required: false, default: "" },
  },
  components: {
    ProductCardTemplate,
    ItemRemovePopup,
    GenericModal,
    Observer,
    Upsell,
  },

  data() {
    return {
      productItem: {},
      quantity: 0,
      cardRounded: Utility.tryJsonParse(this.dataCardRounded, false),
      hideImage: Utility.tryJsonParse(this.dataHideImage, false),
      staticImgBaseUrl: staticImgBaseUrl,
      smallCards: false,
      sessionDependedMethodsProcessed: false,
      cardId: "",
      clientPlatform,
    };
  },
  created() {},
  mounted() {
    this.productItem = JSON.parse(JSON.stringify(this.dataItem));
    this.cardId =
      "prod_id_" + (this.productItem?.parentSkuId || this.productItem?.skuId);
    this.smallCards = Utility.tryJsonParse(this.dataSmallCards, false);
    this.syncProductItemFromCart();

    if (
      this.productObserver &&
      this.dataCounterText &&
      document.getElementById(this.dataCounterText)
    ) {
      this.productObserver.observe(
        document.getElementById(this.dataCounterText),
      );
    }
  },
  updated() {
    //console.warn("updated product : ", Utility.getProductSkuId(this.dataItem));
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.dataCounterText));
    }
  },
  watch: {
    dataItem: {
      deep: true,
      handler() {
        this.productItem = JSON.parse(JSON.stringify(this.dataItem));
        this.syncProductItemFromCart();
      },
    },
    "$store.state.Cart.items": {
      deep: true,
      handler() {
        this.syncProductItemFromCart();
      },
    },
  },
  methods: {
    syncProductItemFromCart() {
      let productItems =
        this.$store.state.Cart.items[Utility.getProductSkuId(this.productItem)];
      if (Array.isArray(productItems) && productItems.length > 0) {
        this.productItem = Utility.mergeDeep(
          productItems[productItems.length - 1],
          this.productItem,
        );
        this.quantity = productItems.length;
      } else {
        this.quantity = 0;
      }
    },

    getProductSkuId() {
      return Utility.getProductSkuId(this.dataItem);
    },
    getProductRating(productItem) {
      let rating = "";
      if (productItem?.ratingAndSubCount) {
        rating = Math.max(
          productItem?.ratingAndSubCount?.global,
          productItem?.ratingAndSubCount?.city,
          productItem?.ratingAndSubCount?.store,
        );
      }
      return rating;
    },
    getIsVeg(productItem) {
      let lastProductItem =
        this.getLastAddedItemFromCart(
          Utility.getProductSkuId(this.productItem),
        ) || {};
      return Object.keys(lastProductItem).length
        ? lastProductItem?.isVeg
        : productItem?.isVeg;
    },
    getCurrentPrice(productItem) {
      let lastProductItem = this.getLastAddedItemFromCart(
        Utility.getProductSkuId(this.productItem),
      );
      return (
        parseFloat(
          lastProductItem?.selectedVariant?.price?.currentPrice?.toFixed(2),
        ) ||
        parseFloat(lastProductItem?.price?.currentPrice?.toFixed(2)) ||
        parseFloat(
          productItem?.variants
            ?.find((x) => x.defaultVariant)
            ?.price?.currentPrice?.toFixed(2),
        ) ||
        parseFloat(productItem?.price?.currentPrice?.toFixed(2))
      );
    },
    getRegularPrice(productItem) {
      let lastProductItem = this.getLastAddedItemFromCart(
        Utility.getProductSkuId(this.productItem),
      );
      return (
        parseFloat(
          lastProductItem?.selectedVariant?.price?.regularPrice?.toFixed(2),
        ) ||
        parseFloat(lastProductItem?.price?.regularPrice?.toFixed(2)) ||
        parseFloat(
          productItem?.variants
            ?.find((x) => x.defaultVariant)
            ?.price?.regularPrice?.toFixed(2),
        ) ||
        parseFloat(productItem?.price?.regularPrice?.toFixed(2))
      );
    },
    getImageUrl(productItem) {
      let mediaBaseUrl = this.$store.state.ProductItems.imgBaseUrl;
      return Utility.getHomeProductImage(
        productItem,
        mediaBaseUrl,
        staticImgBaseUrl,
      );
    },
    getImageArray(productItem) {
      return productItem?.mediaList;
    },
    updateFavourite() {
      EVENT_CLICK_FAVOURITE_BUTTON();
      if (this.isFavourite) {
        if (LocalStorageFunc.isLoggedIn()) {
          this.$store.dispatch(keyMapsAction.REMOVE_FROM_FAVOURITE_API, [
            Utility.getProductSkuId(this.productItem),
          ]);
          this.$store.commit(keyMapsMutation.UNMARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
        } else {
          this.$store.commit(keyMapsMutation.UNMARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
          LocalStorageFunc.removeFromFavouriteIds({
            skuId: Utility.getProductSkuId(this.productItem),
            menuType: this.productItem?.menuType,
          });
        }
      } else {
        if (LocalStorageFunc.isLoggedIn()) {
          this.$store.dispatch(keyMapsAction.ADDTO_FAVOURITE_API, [
            {
              skuId: Utility.getProductSkuId(this.productItem),
              menuType: this.productItem?.menuType,
            },
          ]);
          this.$store.commit(keyMapsMutation.MARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
        } else {
          this.$store.commit(keyMapsMutation.MARK_FAVOURITE_IDS, [
            Utility.getProductSkuId(this.productItem),
          ]);
          LocalStorageFunc.addToFavouriteIds({
            skuId: Utility.getProductSkuId(this.productItem),
            menuType: this.productItem?.menuType,
          });
        }
      }
    },
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    addtocart() {
      this.$store.commit(keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_CARD, {
        categoryId: this.dataCategoryId,
        index: this.dataItemIndex + 1,
      });
      this.$store.commit(
        keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_WITH_UPSELL_ITEM,
        {
          productId: this.getProductSkuId(),
          index: this.dataItemIndex + 1,
        },
      );
      if (this.searchText) {
        EVENT_ADD_FROM_SEARCH({
          sectionPosition: this.dataItemIndex + 1,
          productName: this.productItem?.displayName,
          productPrice: this.getCurrentPrice(this.productItem),
          category: this.searchText,
        });
      }
      if (this.isCustomizable) {
        let cartItems = LocalStorageFunc.getCart();
        if (
          cartItems[Utility.getProductSkuId(this.productItem)] &&
          cartItems[Utility.getProductSkuId(this.productItem)].length > 0
        ) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL,
            true,
          );
        } else {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
            true,
          );
        }
        EVENT_ITEM_ADD({
          sectionPosition: this.dataItemIndex + 1,
          category: this.dataCategoryName,
          productName: this.productItem?.displayName,
          productPrice: this.getCurrentPrice(this.productItem),
          addCounter:
            cartItems[Utility.getProductSkuId(this.productItem)]?.length,
          isCombo: this.productItem?.comboUID ? 1 : 0,
          isCustomisable: 1,
          subcategory: "redirected to customization",
        });
        this.updateShowCustomisableFor();
        return;
      }
      let product =
        this.$store.state.ProductItems.products[
          Object.keys(
            this.$store.state.ProductItems.productCategoryMap[
              Utility.getProductSkuId(this.productItem)
            ],
          )[0]
        ][Utility.getProductSkuId(this.productItem)];
      let cartPayload = { ...product };
      if (product.variants?.find((x) => x.defaultVariant)) {
        cartPayload.selectedVariant = product.variants?.find(
          (x) => x.defaultVariant,
        );
      } else if (product.comboUID) {
        cartPayload.selectedComboVariant = product.groups?.map((group) => ({
          ...group,
          items: [...(group.items || [])],
        }));
      }
      this.$store.commit(keyMapsMutation.ADD_TO_CART, cartPayload);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart.",
      );
      EVENT_ITEM_ADD({
        sectionPosition: this.dataItemIndex + 1,
        category: this.dataCategoryName,
        productName: this.productItem?.displayName,
        productPrice: this.getCurrentPrice(this.productItem),
        addCounter:
          this.$store?.state?.Cart?.items[
            Utility.getProductSkuId(this.productItem)
          ]?.length,
        is_combo: 0,
        is_customisable: 0,
        subcategory: "added to cart",
      });
      setTimeout(this.updateDisableItemToastMsg, 1000);
    },
    removefromcart() {
      if (this.quantity === 1 && !this.isRemoveItemPopup) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SELECTED_ITEM_IN_CART,
          this.getLastAddedItemFromCart(
            Utility.getProductSkuId(this.productItem),
          ),
        );

        this.$store.commit(
          keyMapsMutation.UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED,
          true,
        );

        return;
      }
      this.$store.commit(keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_CARD, {
        categoryId: this.dataCategoryId,
        index: this.dataItemIndex + 1,
      });
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_LAST_INTERACTED_PRODUCT_WITH_UPSELL_ITEM,
      //   {
      //     productId: this.getProductSkuId(),
      //     index: this.dataItemIndex + 1,
      //   }
      // );
      // this.$store.commit(
      //   keyMapsMutation.UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED,
      //     true
      // );
      let cartItems = LocalStorageFunc.getCart();
      let itemId = Utility.getProductSkuId(this.productItem);
      let editItemsListMiniCartCust = {};
      if (
        (this.productItem?.variants?.length > 0 &&
          this.productItem?.variants?.[0].attributes?.length > 0 &&
          cartItems[itemId] &&
          cartItems[itemId].length > 1) ||
        this.productItem?.comboUID
      ) {
        let cartItemsArray = Object.values(
          JSON.parse(JSON.stringify(this.$store.state.Cart.items)),
        );
        let i = 0,
          j = 0;
        cartItemsArray.map((x) => {
          if (x[0]?.parentSkuId == itemId || x[0]?.skuId == itemId) {
            j = i;
            return j;
          } else {
            i++;
          }
        });
        cartItemsArray[j]?.map((item) => {
          let key = "";
          if (item?.selectedVariant) {
            let productItemID = item?.selectedVariant?.skuId;
            key = item.parentSkuId + "*" + productItemID;
          } else {
            let productItemsIdArray = item?.selectedComboVariant
              ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
              .flat();
            key = item.skuId + "*" + productItemsIdArray.join("*");
          }
          editItemsListMiniCartCust[key] = item;
        });
        if (Object.keys(editItemsListMiniCartCust).length > 1) {
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_EDIT_MINI_CART_MODAL,
            true,
          );
          this.updateShowCustomisableFor();
        } else {
          this.$store.commit(
            keyMapsMutation.REMOVE_FROM_CART,
            this.getLastAddedItemFromCart(
              Utility.getProductSkuId(this.productItem),
            ),
          );
          this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
          this.$store.commit(
            keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
            "1 Item removed from the cart.",
          );
          setTimeout(this.updateDisableItemToastMsg, 1000);
        }
      } else {
        this.$store.commit(
          keyMapsMutation.REMOVE_FROM_CART,
          this.getLastAddedItemFromCart(
            Utility.getProductSkuId(this.productItem),
          ),
        );
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
        this.$store.commit(
          keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
          "1 Item removed from the cart.",
        );
        setTimeout(this.updateDisableItemToastMsg, 1000);
      }
    },
    updateShowCustomisableFor() {
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR,
        Utility.getProductSkuId(this.productItem),
      );
    },
    updateShowProductCardInModal() {
      //if (!this.smallCards) return;
      if (this.isOutOfStock || clientPlatform == "Web") return;
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PRODUCT_CARD_IN_MODAL_FOR,
        this.dataItem,
      );
    },
    tagVisbile(tag) {
      return this.dataItem?.metadataMap?.tags?.values[0] === tag;
    },
  },
  computed: {
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.dataCounterText &&
        document.getElementById(this.dataCounterText)
      ) {
        observer.observe(document.getElementById(this.dataCounterText));
      }
      return observer;
    },
    isFavourite() {
      return this.$store.state.ProductItems.favouriteIds[
        Utility.getProductSkuId(this.productItem)
      ];
    },
    hideProductImg() {
      return this.smallCards && this.hideImage ? true : false;
    },
    getLastAddedItemFromCart() {
      return (productId) => {
        return this.$store.getters[keyMapsGetter.GET_LAST_ADDED_ITEM_FROM_CART](
          productId,
        );
      };
    },
    isBestsellerTagVisible() {
      return this.tagVisbile("BESTSELLERS");
    },
    isNewTagVisible() {
      return this.tagVisbile("NEW");
    },
    isCustomizable() {
      if (this.productItem?.comboUID) {
        const groups = this.productItem?.groups || [];
        return groups.some((group) => (group?.items?.length || 0) > 1);
      }
      return (this.productItem?.variants?.length || 0) > 1;
    },
    customizations() {
      return this.productItem?.variants?.length || 0;
    },
    lastInteractedProductId() {
      return this.$store.state.Cart.lastInteractedProductCard?.productId;
    },
    lastInteractedProductWithUpsellId() {
      return this.$store.state.Cart.lastInteractedProductwithUpsellItem
        ?.productId;
    },
    isRemoveItemPopup() {
      return this.$store.state.ProductItems.isRemoveItemPopup;
    },
    showProductCardInModalFor() {
      return this.$store.state.ProductItems.showProductCardInModalFor;
    },
    showUpsell() {
      return (
        this.productItem?.selectedVariant?.upSell?.length > 0 &&
        this.quantity > 0 &&
        !this.dataHorizontalCarousel &&
        this.productItem?.parentSkuId ===
          this.lastInteractedProductWithUpsellId &&
        !Object.keys(this.showProductCardInModalFor).length
      );
    },
    isItemDisabled() {
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let isItemDisabled = false;
      this.productItem?.disabledOrderTypes?.map((x) => {
        if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
      });
      this.productItem?.variants &&
        this.productItem?.variants.map((i) =>
          i.disabledOrderTypes?.map((x) => {
            if (DISABLED_ORDER_TYPE[x] === deliveryType) isItemDisabled = true;
          }),
        );
      return isItemDisabled;
    },
  },
};
</script>

<style scoped></style>
